import { createApp } from 'vue'
import { createMetaManager } from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import ElementPlus from 'element-plus'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'element-plus/dist/index.css'
import '@/styles/index.scss' // global css (must be after element-plus to override defaults)
import './mock' // simulation data

import App from './App'
import { registerSvgIcon } from './icons' // icon
import i18n from './lang/index' // Internationalization
import router from './router'
import store from './store'
import { initPosthog, setupVueErrorTracking } from './telemetry/posthogTelemetry'

const app = createApp({
  ...App
})

initPosthog()

app.use(router)
app.use(store)
app.use(i18n)
app.use(VueScrollTo)
app.use(createMetaManager())
app.use(ElementPlus)

setupVueErrorTracking(app)

app.mount('#app')

registerSvgIcon(app)
